module.exports = __webpack_public_path__ + "static/img/22.d5ee8f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/22.jpg
// module id = Xayn
// module chunks = 1